module.exports = __webpack_public_path__ + "img/pos2_banner.c79a47c0.png";